module.exports = __webpack_public_path__ + "img/Imagen 11.56a9fa1d.jpg";